<template>
  <div>
    <button class="btn-reset" @click="showOnboarding = !showOnboarding" v-if="incompleteMainItems.length > 0">
      <span class="tw-flex tw-items-center tw-gap-3">
        <span class="tw-flex tw-relative tw-h-full">
          <i class="fas fa-tasks fa-lg tw-text-gray-500 tw-text-lg tw-mr-2"></i>
          <span v-if="incompleteMainItems.length > 0"
            class="tw-absolute tw-top-0 tw-right-0 tw-flex tw-items-center tw-justify-center tw-rounded-full bg-danger tw-text-white tw-w-5 tw-h-4 tw-text-xs">
            {{ incompleteMainItems.length }}
          </span>
        </span>
        <span class="tw-flex tw-flex-col tw-gap-1" v-if="showOnboarding">
          <span class="tw-font-medium tw-truncate">Onboarding checklist</span>
          <span class="tw-rounded-full tw-bg-gray-100 tw-h-2">
            <span class="tw-flex tw-rounded-full bg-primary tw-h-2" :style="{ width: percentComplete + '%' }"></span>
          </span>
        </span>
      </span>
    </button>
    <div v-if="showOnboarding && incompleteMainItems.length > 0" class="tw-fixed tw-top-12 tw-right-8 tw-p-6 tw-z-50">
      <div class="card tw-shadow-md">
        <div class="card-body p-3">
          <div class="tw-flex tw-justify-between">
            <h5 class="m-0 mr-2">
              <template v-if="currentMainSection">
                {{ mainSection(currentMainSection).title }}
              </template>
              <template v-else>
                Get started
              </template>
            </h5>
            <button class="btn p-0 !tw-text-gray-500" @click="showOnboarding = false">
              <i class="fas fa-lg fa-xmark"></i>
            </button>
          </div>

          <div class="tw-mt-3 tw-text-sm">{{ percentComplete }}% complete</div>
          <div class="tw-rounded-full tw-bg-gray-100 tw-h-4 tw-mt-2">
            <div class="tw-rounded-full bg-primary tw-h-4" :style="{ width: percentComplete + '%' }"></div>
          </div>

          <div class="tw-flex tw-flex-col tw-gap-3 tw-mt-6">
            <template v-if="!currentMainSection">
              <button class="btn-reset tw-flex tw-items-center tw-gap-4"
                      @click="mainSectionSelected(item.key)"
                      v-for="item in sortedOnboardingStructure">
                <i
                  :class="{ 'far fa-circle tw-text-gray-300': !mainSectionCompleted(item.key), 'fas fa-check-circle text-primary': mainSectionCompleted(item.key) }"
                  class="fa-lg"/>
                <span class="tw-font-medium tw-text-gray-600 hover:tw-text-gray-500"
                      :class="{ 'tw-opacity-50': mainSectionCompleted(item.key) }">
                  {{ item.title }}
                </span>
                <span class="tw-flex-grow"></span>
                <i class="fas fa-chevron-right tw-text-gray-500 tw-text-md"></i>
              </button>
            </template>
            <template v-else>
              <button class="btn-reset tw-flex tw-items-center tw-gap-4 tw-text-gray-600 hover:tw-text-gray-500"
                      @click="currentMainSection = null">
                <i class="fas fa-chevron-left tw-text-md"></i>
                <span class="tw-font-medium">Back</span>
              </button>
              <button class="btn-reset tw-flex tw-items-center tw-gap-4"
                      @click="runAction(currentMainSection, item.key)"
                      v-for="item in mainSection(currentMainSection).sections">
                <i
                  :class="{ 'far fa-circle tw-text-gray-300': !subSectionCompleted(currentMainSection, item.key), 'fas fa-check-circle text-primary': subSectionCompleted(currentMainSection, item.key) }"
                  class="fa-lg"/>
                <span class="tw-font-medium tw-text-gray-600 hover:tw-text-gray-500"
                      :class="{ 'tw-opacity-50': subSectionCompleted(currentMainSection, item.key) }">
                {{ item.title }}
              </span>
                <span class="tw-flex-grow"></span>
                <i v-if="item.arrow" class="fas fa-chevron-right tw-text-gray-500 tw-text-md"></i>
              </button>
            </template>

          </div>

        </div>
      </div>
    </div>

    <b-modal v-model="showProfileEditModal" title="Edit Profile Info" hide-footer size="lg">
      <onboarding-profile-edit :user-attributes="['firstName', 'lastName']" @cancel="showProfileEditModal = false"
                               @saved="handleProfileChanged"/>
    </b-modal>

    <b-modal v-model="showAvatarEditModal" title="Profile Avatar" hide-footer size="lg">
      <onboarding-avatar-edit @cancel="showAvatarEditModal = false" @saved="handleAvatarChanged"/>
    </b-modal>

    <b-modal v-model="showInterestsEditModal" title="Edit Interests" hide-footer size="lg" hide-header>
      <onboarding-interests @cancel="showInterestsEditModal = false"
                            @saved="showInterestsEditModal = false; onboarding.profile_interests = true"/>
    </b-modal>

    <b-modal v-model="showJobTitleEditModal" title="Edit Interests" hide-footer size="lg" hide-header>
      <onboarding-profile-edit :user-attributes="['jobTitle']" @cancel="showJobTitleEditModal = false"
                               @saved="showJobTitleEditModal = false; onboarding.profile_job_title = true"/>
    </b-modal>

    <b-modal v-model="showBusinessNameModal" title="Edit Account Business Name" hide-footer size="lg">
      <onboarding-organization-edit :organization-attributes="['name']" @cancel="showBusinessNameModal = false"
                                    @saved="showBusinessNameModal = false; onboarding.account_business_name = true"/>
    </b-modal>

    <b-modal v-model="showAccountTypeModal" title="Edit Account Type" hide-footer size="lg">
      <onboarding-organization-edit :organization-attributes="['organizationType']"
                                    :account-type-set="accountTypeSet"
                                    @cancel="showAccountTypeModal = false"
                                    @saved="handleOrganizationSaved"/>
    </b-modal>

    <b-modal v-model="showIndustryModal" title="Edit Industry" hide-footer size="lg">
      <onboarding-organization-edit :organization-attributes="['industry']" @cancel="showIndustryModal = false"
                                    @saved="showIndustryModal = false; onboarding.account_industry = true"/>
    </b-modal>

    <b-modal v-model="showSubscriptionModal" title="Select Subscription Plan" hide-footer size="xl">
      <onboarding-popup-payment-modal-container @cancel="showSubscriptionModal = false"
                                                @saved="showSubscriptionModal = false; onboarding.subscription_type = true"/>
    </b-modal>

    <b-modal v-model="showPaymentMethodModal" title="Add Payment Method" hide-footer lazy>
      <onboarding-payment-method @cancel="showPaymentMethodModal = false"
                                 @saved="showPaymentMethodModal = false; onboarding.payment_billing_method = true; onboarding.payment_address = true"/>
    </b-modal>

    <b-modal v-model="showBillingModal" title="Edit Billing Address" hide-footer size="lg">
      <onboarding-billing @cancel="showBillingModal = false"
                          @saved="showBillingModal = false; onboarding.payment_address = true"/>
    </b-modal>

  </div>
</template>

<script>
import OnboardingProfileEdit from "./OnboardingProfileEdit.vue";
import OnboardingAvatarEdit from "./OnboardingAvatarEdit.vue";
import OnboardingInterests from "./OnboardingInterests.vue";
import OnboardingOrganizationEdit from "./OnboardingOrganizationEdit.vue";
import {OrganizationsApi} from "../../Api/OrganizationsApi.js";
import OnboardingPlans from "./OnboardingPlans.vue";
import OnboardingPopupPaymentModalContainer from "./OnboardingPopupPaymentModalContainer.vue";
import PaymentMethodForm from "../PaymentMethods/PaymentMethodForm.vue";
import OnboardingPaymentMethod from "./OnboardingPaymentMethod.vue";
import OnboardingBilling from "./OnboardingBilling.vue";
import {SubscriptionsApi} from "../../Api/SubscriptionsApi.js";

export default {
  components: {
    OnboardingBilling,
    OnboardingPaymentMethod,
    PaymentMethodForm,
    OnboardingPopupPaymentModalContainer,
    OnboardingPlans,
    OnboardingOrganizationEdit, OnboardingInterests, OnboardingAvatarEdit, OnboardingProfileEdit
  },
  data() {
    return {
      onboarding: null,
      accountTypeSet: null,
      organizationType: null,
      organizationOwner: null,
      showOnboarding: this.readShowOnboarding(),
      currentMainSection: null,
      showProfileEditModal: false,
      showAvatarEditModal: false,
      showInterestsEditModal: false,
      showJobTitleEditModal: false,
      showBusinessNameModal: false,
      showAccountTypeModal: false,
      showIndustryModal: false,
      showSubscriptionModal: false,
      showPaymentMethodModal: false,
      showBillingModal: false,

      subscriptionSetup: null,
    }
  },

  watch: {
    showOnboarding(val) {
      localStorage.setItem('onboarding-popup-open', `${val}`)
    }
  },

  methods: {
    readShowOnboarding() {
      return localStorage.getItem('onboarding-popup-open') === 'true'
    },
    handleProfileChanged() {
      this.showProfileEditModal = false;
      this.onboarding.profile_name = true
      window.location.reload()
    },
    handleAvatarChanged() {
      this.onboarding.profile_avatar = true
      window.location.reload()
    },
    handleOrganizationSaved(params) {
      // showAccountTypeModal = false; onboarding.account_type = true
      this.showAccountTypeModal = false;
      this.onboarding.account_type = true;
      if (params && params.organization_type) {
        this.organizationType = params.organization_type;
      }
    },
    mainSectionSelected(key) {
      if (key === 'subscription') {
        if (this.subscriptionSetup) {
          window.location.href = "/customers/billing"
        } else {
          this.showSubscriptionModal = true;
        }
      } else {
        this.currentMainSection = key;
      }
    },
    mainSection(name) {
      return this.onboardingStructure.find(section => section.key === name);
    },

    subSection(mainKey, sectionKey) {
      const mainSection = this.mainSection(mainKey);
      if (!mainSection) return null;

      const section = mainSection.sections.find(section => section.key === sectionKey);
      if (!section) return null;

      return section
    },

    mainSectionCompleted(key) {
      if (!key) return false;
      const mainSection = this.mainSection(key);
      if (!mainSection) return false;
      return mainSection.sections.every(section => section.completed === true);
    },

    subSectionCompleted(mainKey, sectionKey) {
      const section = this.subSection(mainKey, sectionKey);
      if (!section) return false;
      return section.completed;
    },

    runAction(mainKey, sectionKey) {
      const mainSection = this.mainSection(mainKey);
      const section = this.subSection(mainKey, sectionKey);
      if (!section) return false;

      switch (mainSection.key) {
        case "profile":
          switch (section.key) {
            case "profile_name":
              this.showProfileEditModal = true;
              break;
            case "profile_avatar":
              this.showAvatarEditModal = true;
              break;
            case "profile_interests":
              this.showInterestsEditModal = true;
              break;
            case "profile_job_title":
              this.showJobTitleEditModal = true;
              break;
          }
          break;
        case "account":
          switch (section.key) {
            case "account_business_name":
              this.showBusinessNameModal = true;
              break;
            case "account_type":
              this.showAccountTypeModal = true;
              break;
            case "account_industry":
              this.showIndustryModal = true;
              break;
          }
          break;
        case "payment":
          switch (section.key) {
            case "payment_billing_method":
              this.showPaymentMethodModal = true;
              break;
            case "payment_address":
              this.showBillingModal = true;
              break;
          }
      }
    },

  },

  computed: {
    showVendorSetup() {
      return false // temporary remove
      // return ["agency", "enterprise"].includes(this.organizationType);
    },

    incompleteMainItems() {
      return this.sortedOnboardingStructure.filter(section => !this.mainSectionCompleted(section.key));
    },

    percentComplete() {
      const mainCount = this.sortedOnboardingStructure.length;
      if (mainCount === 0) return 0;
      const completedMainCount = this.sortedOnboardingStructure.filter(section => this.mainSectionCompleted(section.key)).length;
      return Math.round(completedMainCount / mainCount * 100);
    },

    sortedOnboardingStructure() {
      // completed last
      return this.onboardingStructure.sort((a, b) => {
        if (this.mainSectionCompleted(a.key) && !this.mainSectionCompleted(b.key)) return 1;
        if (!this.mainSectionCompleted(a.key) && this.mainSectionCompleted(b.key)) return -1;
        return 0;
      });
    },
    onboardingStructure() {
      if (!this.onboarding) return [];

      let data = [
        {
          key: "profile",
          title: "Complete your profile",
          sections: [
            {
              key: "profile_name",
              title: "Name",
              completed: this.onboarding.profile_name,
              arrow: true
            },
            {
              key: "profile_avatar",
              title: "Avatar Image",
              completed: this.onboarding.profile_avatar,
              arrow: true
            },
            {
              key: "profile_interests",
              title: "Interests",
              completed: this.onboarding.profile_interests,
              arrow: true
            },
            {
              key: "profile_job_title",
              title: "Job Title",
              completed: this.onboarding.profile_job_title,
              arrow: true
            }
          ]
        },
        {
          key: "account",
          title: "Setup your account",
          sections: [
            {
              key: "account_type",
              title: "Account type",
              completed: this.onboarding.account_type,
              arrow: true
            },
            {
              key: "account_business_name",
              title: "Business name",
              completed: this.onboarding.account_business_name,
              arrow: true
            },
            {
              key: "account_industry",
              title: "Industry",
              completed: this.onboarding.account_industry,
              arrow: true
            }
          ]
        },
        {
          key: "payment",
          title: "Billing & payments",
          sections: [
            {
              key: "payment_billing_method",
              title: "Billing method",
              completed: this.onboarding.payment_billing_method,
              arrow: true
            },
            {
              key: "payment_address",
              title: "Address",
              completed: this.onboarding.payment_address,
              arrow: true
            }
          ]
        },
        {
          key: "subscription",
          title: "Choose your plan",
          sections: [
            {
              key: "subscription_type",
              title: "Subscription",
              completed: this.onboarding.subscription_type,
              arrow: true
            }
          ]
        },
        {
          key: "vendor",
          title: "Vendor setup",
          sections: [
            {
              key: "vendor_contact_sales",
              title: "Contact sales team",
              completed: this.onboarding.vendor_contact_sales,
              arrow: false
            },
            {
              key: "vendor_setup_docs",
              title: "Vendor setup docs",
              completed: this.onboarding.vendor_setup_docs,
              arrow: false
            },
            {
              key: "vendor_contracts_signed",
              title: "Contracts signed",
              completed: this.onboarding.vendor_contracts_signed,
              arrow: false
            },
            {
              key: "vendor_purchase_order_issued",
              title: "Purchase order issued",
              completed: this.onboarding.vendor_purchase_order_issued,
              arrow: false
            }
          ]
        },
      ]

      if (!this.showVendorSetup) {
        data = data.filter(section => section.key !== "vendor");
      }

      // only allow profile if organizationOwner != true
      if (!this.organizationOwner) {
        data = data.filter(section => section.key === "profile");
      }

      return data;
    },
  },

  async mounted() {
    try {
      const onboarding = await OrganizationsApi.getOnboarding();
      this.onboarding = onboarding.data
      this.organizationType = onboarding.organization_type;
      this.organizationOwner = onboarding.owner;
      this.accountTypeSet = onboarding.data.account_type
    } catch (error) {
      console.log(error);
    }

    try {
      await SubscriptionsApi.getSubscription()
      this.subscriptionSetup = true
    } catch (e) {
      this.subscriptionSetup = false
    }
  }

}
</script>
